import OneSignal from 'onesignal-cordova-plugin';
import { proxyOsNotification, User } from './Global';
import { Capacitor } from '@capacitor/core';

export function OneSignalInit(): void {
    if (Capacitor.getPlatform() == 'web') {
        return;
    }

    OneSignal.initialize('64a011b1-9546-4959-b7f9-3b9f96198f28');

    OneSignal.Notifications.addEventListener('click', (jsonData) => {
        proxyOsNotification.notification = jsonData.notification;
        console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
        // TODO: handle session expired and redirect to login page and redirect to the right page
    });
}

export function updateUserId(user: User | null) {
    if (Capacitor.getPlatform() == 'web') {
        return;
    }

    if (!user) {
        OneSignal.User.removeTags(['role', 'url']);
        OneSignal.logout();

        return;
    }

    OneSignal.login(user.dbuuid + '_' + user.uid);
    OneSignal.User.addTags({
        role: user.type,
        url: user.baseUrl,
    });
}
